import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import {
  BricksModalComponent,
  BricksModalHeaderComponent,
  BricksModalBodyComponent,
  BricksModalFooterComponent,
} from '@enbw_bricks/ui'

@Component({
  selector: 'app-battery-usage-hint',
  templateUrl: './battery-usage-hint.component.html',
  styleUrl: 'battery-usage-hint.component.scss',
  imports: [BricksModalComponent, BricksModalHeaderComponent, BricksModalBodyComponent, BricksModalFooterComponent],
})
export class BatteryUsageHintComponent {
  matDialogRef = inject<MatDialogRef<BatteryUsageHintComponent>>(MatDialogRef)

  closeDialog() {
    this.matDialogRef.close()
  }
}
